import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useThemeUI } from 'theme-ui';
import WireFrameCell from '../../../../elements/wireframe-cell';
import { Badge } from '@uswitch/spark';
import CellBase from './cell-base';
import { WireFrame } from './wireframe-cell';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableHeader = function ProductTableHeader(_ref) {
  var _ref$badges = _ref.badges,
      badges = _ref$badges === void 0 ? [] : _ref$badges,
      preTitle = _ref.preTitle,
      rowTitle = _ref.rowTitle,
      subtitle = _ref.subtitle,
      _ref$addons = _ref.addons,
      addons = _ref$addons === void 0 ? [] : _ref$addons,
      image = _ref.image,
      _ref$card = _ref.card,
      card = _ref$card === void 0 ? false : _ref$card,
      _ref$isWireFrame = _ref.isWireFrame,
      isWireFrame = _ref$isWireFrame === void 0 ? false : _ref$isWireFrame;

  var _useThemeUI = useThemeUI(),
      _useThemeUI$theme$com = _useThemeUI.theme.compounds['product-table'];

  _useThemeUI$theme$com = _useThemeUI$theme$com === void 0 ? {} : _useThemeUI$theme$com;
  var _useThemeUI$theme$com2 = _useThemeUI$theme$com.padding;
  _useThemeUI$theme$com2 = _useThemeUI$theme$com2 === void 0 ? {} : _useThemeUI$theme$com2;
  var _useThemeUI$theme$com3 = _useThemeUI$theme$com2.paddingBottom,
      paddingBottom = _useThemeUI$theme$com3 === void 0 ? ['0', 'sm'] : _useThemeUI$theme$com3;
  var pb = paddingBottom || '0';
  var wireFrameStyles = {
    image: {
      width: ['45%', '15%'],
      marginRight: 'xxs',
      height: '70px',
      borderRadius: '3px'
    },
    title: {
      width: ['93%', '55%'],
      height: '14px'
    }
  }; // For displaying USPs in product table header

  var uspJsx = function uspJsx(subtitle) {
    return subtitle.map(function (item) {
      var terms = ['voucher', 'bill credit', 'reward card', 'gift card'];
      var voucherStyles = terms.some(function (term) {
        return item.toLowerCase().includes(term);
      }) ? {
        border: '1px solid rgb(130, 202, 80)'
      } : {};
      var blackFridayStyles = item.toLowerCase().includes('black friday') ? {
        background: 'black',
        color: 'white',
        border: '1px solid black',
        fontWeight: 'bold'
      } : {};

      var badgeStyles = _objectSpread(_objectSpread({
        margin: '5px 5px 0 0',
        border: '1px solid rgb(255, 170, 85)',
        background: 'white'
      }, voucherStyles), blackFridayStyles);

      return _jsx(Badge, {
        size: 'medium',
        sx: badgeStyles,
        children: item
      });
    });
  };

  var subtitleJsx = function subtitleJsx(subtitle) {
    if (Array.isArray(subtitle)) {
      return uspJsx(subtitle);
    }

    return _jsx("span", {
      sx: {
        marginTop: '10px',
        fontSize: 'xs',
        variant: 'compounds.product-table.row.subtitle'
      },
      children: subtitle
    });
  };

  return _jsx("div", {
    sx: {
      pb: image ? '' : 'xs'
    },
    children: _jsxs("div", {
      sx: {
        borderBottom: image ? '0' : '1px solid',
        paddingBottom: image ? pb : 'sm',
        marginTop: badges.length ? 0 : -6,
        display: 'flex',
        alignItems: card ? 'baseline' : 'center',
        flexDirection: card ? 'column' : 'row',
        minHeight: card ? ['0', '0', '160px'] : '0',
        variant: badges.length && !card ? 'compounds.product-table.badge-wrapper' : badges.length && card ? 'compounds.product-table.badge-wrapper.card' : undefined
      },
      children: [isWireFrame && _jsx(WireFrameCell, {
        styles: wireFrameStyles.image
      }), !isWireFrame && image && image, isWireFrame && _jsx(WireFrame, {
        type: "header"
      }), !isWireFrame && rowTitle && _jsxs(CellBase, {
        sx: {
          marginX: -8,
          marginY: -6
        },
        children: [preTitle && _jsx("span", {
          sx: {
            fontSize: 'xs',
            variant: 'compounds.product-table.row.pretitle'
          },
          children: preTitle
        }), _jsx("h3", {
          sx: {
            margin: 0,
            variant: "compounds.product-table.".concat(image && 'variants.redesign.', "row.title"),
            pl: card && '0 !important'
          },
          children: rowTitle
        }), subtitle && subtitleJsx(subtitle)]
      }), addons]
    })
  });
};

export default ProductTableHeader;
//# sourceMappingURL=header.js.map